export default {
    menuList: [
        {
            menuId: 131,
            menuName: "运单列表",
            jumpUrl: "",
            children: [
                {
                    menuId: 1,
                    menuName: "运单列表",
                    jumpUrl: "/WaybillManage/ComprehensiveQuery",
                    children: [],
                },
                // {
                //     menuId: 2,
                //     menuName: "运单附件",
                //     jumpUrl: "/WaybillManage/WaybillAttachment",
                //     children: [],
                // },
                {
                    menuId: 2,
                    menuName: "运单跟踪",
                    jumpUrl: "/WaybillManage/WaybillTracking",
                    children: [],
                },

            ]
        },
        // {
        //     menuId: 132,
        //     menuName: "对账单",
        //     jumpUrl: "",
        //     children: [{
        //         menuId: 1,
        //         menuName: "对账单",
        //         jumpUrl: "/WaybillManage/statementAccount",
        //         children: [],
        //     },

        //     ],
        // },
        // {
        //     menuId: 133,
        //     menuName: "消息通知",
        //     jumpUrl: "/message/messageList",
        //     children: [],
        // },


    ]
}